import React, { forwardRef } from 'react';

// Action icons of the assigned-transaction rows (TransactionsSection) and the transaction preview
// (TransactionDetailModal). Inline SVGs drawn in currentColor, so the colour and the red hover of
// "Zuordnung entfernen" come from the .transaction-action-icon rules in general/styles.scss.
// forwardRef because Mantine's Tooltip needs a ref on its child.
const Svg = forwardRef(({ size = 14, className = '', children, ...props }, ref) => (
  <svg
    ref={ref}
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`transaction-action-icon ${className}`}
    {...props}
  >
    {children}
  </svg>
));

export const ViewTransactionIcon = forwardRef((props, ref) => (
  <Svg ref={ref} {...props}>
    <path d="M1 8C2.8 4.6 5.2 3 8 3C10.8 3 13.2 4.6 15 8C13.2 11.4 10.8 13 8 13C5.2 13 2.8 11.4 1 8Z" strokeWidth="1.5" />
    <circle cx="8" cy="8" r="2.2" fill="currentColor" stroke="none" />
  </Svg>
));

export const GoToTransactionIcon = forwardRef((props, ref) => (
  <Svg ref={ref} {...props}>
    <path d="M3.5 12.5L12.5 3.5M5.5 3.5H12.5V10.5" strokeWidth="1.8" />
  </Svg>
));

export const RemoveAssignmentIcon = forwardRef(({ className = '', ...props }, ref) => (
  <Svg ref={ref} className={`transaction-action-icon-remove ${className}`} {...props}>
    <path d="M3.5 3.5L12.5 12.5M12.5 3.5L3.5 12.5" strokeWidth="1.8" />
  </Svg>
));

export const CopyValueIcon = forwardRef((props, ref) => (
  <Svg ref={ref} {...props}>
    <rect x="5.5" y="5.5" width="8.5" height="8.5" rx="1.5" strokeWidth="1.5" />
    <path d="M2.5 10.5V3.5C2.5 2.95 2.95 2.5 3.5 2.5H10.5" strokeWidth="1.5" />
  </Svg>
));
